export default __webpack_public_path__ + "static/media/modal01.82337876.png";